(function() {
  try {
    const currentPath = window.location.pathname;
    const targetPath = '/products/rapid-force-level-ii-holster';

    // Normalize path to ignore trailing slashes for comparison
    const normalizedPath = currentPath.replace(/\/$/, '');
    const normalizedTarget = targetPath.replace(/\/$/, '');

    // If we are already on the target page, do not redirect
    if (normalizedPath === normalizedTarget) {
      return;
    }

    // Only apply redirect rules to product pages
    if (/^\/products\//i.test(currentPath)) {
      // Exclude shell-only pages (containing 'shell' or 'shells')
      if (/shell/i.test(currentPath)) {
        return;
      }

      // Check if it is a Level II page (containing 'level-ii', 'level-2', or 'lvl-2', but NOT 'level-iii')
      if (/level-ii(?!i)|level-2|lvl-2/i.test(currentPath)) {
        window.location.replace(targetPath);
      }
    }
  } catch (e) {
    console.error('Level II redirects error:', e);
  }
})();
